module.exports = "<div>general works</div>\n"